import React, { useEffect } from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { DollarSign, Wrench, Lightbulb, Cable, Zap, Percent } from 'lucide-react';

const STORAGE_KEY = 'sno_lighting_pricing_defaults';

export default function PricingForm({ pricing, onChange }) {
  // Load defaults from localStorage on mount if pricing is empty
  useEffect(() => {
    if (!pricing || Object.keys(pricing).length === 0) {
      const savedDefaults = localStorage.getItem(STORAGE_KEY);
      if (savedDefaults) {
        try {
          const defaults = JSON.parse(savedDefaults);
          onChange(defaults);
        } catch (e) {
          console.error('Failed to load pricing defaults:', e);
        }
      }
    }
  }, []);

  const updatePricing = (key, value) => {
    const newPricing = { ...pricing, [key]: parseFloat(value) || 0 };
    onChange(newPricing);
    // Save to localStorage as defaults
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newPricing));
  };

  const fields = [
    { key: 'labor_rate_per_hour', label: 'Labor Rate (per hour)', icon: Wrench, placeholder: '85.00' },
    { key: 'light_cost_per_unit', label: 'Light Cost (per puck)', icon: Lightbulb, placeholder: '3.50' },
    { key: 'wire_cost_per_foot', label: 'Wire Cost (per ft)', icon: Cable, placeholder: '0.75' },
    { key: 'transformer_cost', label: 'Transformer Cost', icon: Zap, placeholder: '150.00' },
    { key: 'misc_materials', label: 'Misc Materials', icon: DollarSign, placeholder: '50.00' },
    { key: 'discount_percent', label: 'Discount (%)', icon: Percent, placeholder: '0' },
  ];

  return (
    <div className="space-y-4">
      {fields.map(({ key, label, icon: Icon, placeholder }) => (
        <div key={key} className="space-y-2">
          <div className="flex items-center gap-2">
            <Icon className="w-4 h-4 text-amber-600" />
            <Label className="text-sm font-medium">{label}</Label>
          </div>
          <div className="relative">
            {key !== 'discount_percent' && (
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">$</span>
            )}
            <Input
              type="number"
              step="0.01"
              min="0"
              value={pricing[key] || ''}
              onChange={(e) => updatePricing(key, e.target.value)}
              placeholder={placeholder}
              className={key !== 'discount_percent' ? 'pl-7' : ''}
            />
          </div>
        </div>
      ))}
    </div>
  );
}